<template>
  <b-row>
    <b-col lg="12">
      <card>
        <!-- Card header -->
        <h3 slot="header" class="mb-0">Editar tipo de Requerimemento</h3>
        <!-- Card body -->
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form
            class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)"
          >
            <div class="form-row mb-5">
              <b-col md="12">
                <base-input
                  label="Título"
                  name="Título"
                  placeholder="Título do tipo de requerimento"
                  success-message="Ok!"
                  rules="required"
                  v-model="form.title"
                >
                </base-input>
              </b-col>

              <b-col md="12">
                <h4>Informações ({{ editorTextLength }})</h4>
                <form @input="getInput">
                  <html-editor
                    @input="getInputEditor"
                    @editorTextLength="getEditorTextLength"
                    :value="issuesTypes.description"
                    :limit-length-text="editorLimitTextLength"
                  ></html-editor>
                </form>
              </b-col>
              <!-- <b-col md="12">
                <quill-input></quill-input>
              </b-col> -->
            </div>

            <base-button
              :disabled="disableSubmitButton"
              type="primary"
              native-type="submit"
              >{{ submitButtonText }}</base-button
            >
          </form>
        </validation-observer>
      </card>
    </b-col>
  </b-row>
</template>
<script>
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import QuillInput from "@/components/Inputs/QuillInput";
import swal from "sweetalert2";
import { Select, Option } from "element-ui";
import bocapioService from "@/services/nodejs/index";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    HtmlEditor,
    QuillInput
  },
  props: {
    issuesTypes: {
      type: Object
    }
  },
  data() {
    return {
      validated: false,
      submitButtonText: "Enviar",
      showAlert: false,
      editorTextLength: null,
      disableSubmitButton: false,
      editorLimitTextLength: 200,
      form: {
        title: null,
        description: null,
        agree: false
      },
      IssuesTypesId: null
    };
  },

  mounted() {
    console.log("parameter", this.issuesTypes);
    this.form.title = this.issuesTypes.title;
    this.form.description = this.issuesTypes.description;
    this.form.id = this.issuesTypes.id;
  },

  methods: {
    getInput(input) {},
    getInputEditor(payload) {
      this.form.description = payload;
    },
    getEditorTextLength(payload) {
      this.editorTextLength = payload;
    },

    async firstFormSubmit() {
      this.submitButtonText = "Enviando...";
      this.disableSubmitButton = true;
      bocapioService
        .updateTipoRequerimento(
          this.form.id,
          this.form.title,
          this.form.description
        )
        .then(rsp => {
          console.log("rsp updateTipoRequerimento", rsp.data);
          this.showSwal(
            "Sucesso!!",
            "Item Editado com sucesso !!",
            "primary",
            "success"
          );
          this.$router.push("/configurations/issuesTypes");
        })
        .catch(() => {
          this.$router.push("/configurations/issuesTypes");
          this.showSwal(
            "Erro!!",
            "Algo deu errado. Tente novamente mais tarde !!",
            "warning",
            "warning"
          );
          this.disableSubmitButton = false;
        });
    },

    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`,
        icon: icon
      });
    }
  }
};
</script>
<style scoped>
.ql-clipboard {
  visibility: hidden;
}

#counter {
  border: 1px solid #ccc;
  border-top: 0;
  padding: 0.5rem 1rem;
  text-align: right;
}
</style>
